"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userpilotObject = void 0;
var userpilotObject = exports.userpilotObject = function userpilotObject(_ref) {
  var user = _ref.user,
    platform = _ref.platform;
  if (!user || !platform) {
    return {};
  }
  var teamNames = user === null || user === void 0 ? void 0 : user.teams.map(function (teamMember) {
    return teamMember.team.name;
  });
  var teamRoles = user === null || user === void 0 ? void 0 : user.teams.map(function (teamMember) {
    return teamMember.role;
  });
  var domain = platform.domain;
  var roleFlags = {
    isAdmin: teamRoles.includes('ADMIN'),
    isEditor: teamRoles.includes('EDITOR'),
    isPlatformAdmin: user.isPlatformAdmin,
    isSuperPlatformAdmin: user.isIPA
  };
  return {
    name: user.fullName,
    email: user.email,
    created_at: user.dateCreated,
    teamNames: teamNames,
    teamRoles: roleFlags,
    company: {
      id: platform === null || platform === void 0 ? void 0 : platform.id,
      host: platform === null || platform === void 0 ? void 0 : platform.platformSlug,
      site: domain === null || domain === void 0 ? void 0 : domain.slug,
      sitename: domain === null || domain === void 0 ? void 0 : domain.name
    }
  };
};
//# sourceMappingURL=userpilot-utils.js.map